import { forwardRef, useEffect, useState } from "react";

import styled from "styled-components/macro";

import { useCardProvider } from "Payments/globalPaymentsStateHooks";
import { motion } from "framer-motion";

import useCreditCardEntryState from "./state";
import { InputOutline, SmallNumberInput, iPhoneMini } from "./styles";

const NameInput = forwardRef(({ defaultName, submitting }, ref) => {
  const { providerIsWePay } = useCardProvider();
  const [isHovering, setIsHovering] = useState(false);
  const [isFocused, setIsFocused] = useState(false);

  const [{ name, canBeEdited, isEditing, cardType }, dispatch] =
    useCreditCardEntryState();
  const cardTypeShortname = cardType?.shortname || "";

  const shouldShowDisplayOnly = canBeEdited && !isEditing;

  const updateName = (e) => {
    dispatch({
      type: "Remove Multiple Error Messages",
      messages: ["empty_name"],
    });
    dispatch({ type: "Set Name", name: e.target.value });
  };

  useEffect(() => {
    if (defaultName) dispatch({ type: "Set Name", name: defaultName });
  }, [defaultName]);

  return (
    <Wrapper
      onHoverStart={() => setIsHovering(true)}
      onHoverEnd={() => setIsHovering(false)}
      data-cy="fund-it-card-your-name"
    >
      <InputOutline
        isFocused={!submitting && isFocused}
        isHovering={!shouldShowDisplayOnly && !submitting && isHovering}
        style={{ top: "1px" }}
      />
      <SmallNumberInput
        value={name}
        ref={ref}
        type="text"
        name="ccname"
        autoComplete="cc-name"
        tabIndex={providerIsWePay ? 4 : 0}
        onChange={updateName}
        onFocus={() => setIsFocused(true)}
        onBlur={() => setIsFocused(false)}
        placeholder="Name on card"
        disabled={shouldShowDisplayOnly || submitting}
        useDarkPlaceholder={cardTypeShortname === "amex"}
      />
    </Wrapper>
  );
});

NameInput.displayName = "NameInput";
export default NameInput;

const Wrapper = styled(motion.div)`
  position: relative;
  max-width: fit-content;
  flex-grow: 0;
  padding: 6px 12px 6px 12px;
  margin-top: 0px;
  @media screen and (max-width: ${iPhoneMini.cssWidth}) {
    padding: 5px 10px 5px 10px;
  }
`;
